import { Box } from '@wix/design-system';
import { PageDisclaimer, StudioCta } from '@wix/package-picker-shared-studio';
import React from 'react';
import { StudioPackagePickerModule } from '../../modules/studio-package-picker.module';
import { CycleSelector } from '../CycleSelector';
import { TrustBuildersSection } from '../TrustBuildersSection';

export interface CycleSectionProps {
  onContinue: () => void;
}

export const CycleSection = ({ onContinue }: CycleSectionProps) => {
  const { t } = StudioPackagePickerModule.internals.useTranslations();

  return (
    <Box width="100%" direction="vertical" align="center">
      <Box
        width="100%"
        maxWidth="720px"
        direction="vertical"
        margin="40px SP3 0 SP3"
        gap="SP5"
      >
        <CycleSelector />
        <Box align="right">
          <Box>
            <StudioCta onClick={onContinue} filled size="large">
              {t('subscription_btn.continue_to_checkout')}
            </StudioCta>
          </Box>
        </Box>
      </Box>
      <Box
        width="100%"
        marginTop="72px"
        padding="0 40px"
        boxSizing="border-box"
        textAlign="center"
        align="center"
      >
        <PageDisclaimer />
      </Box>
      <TrustBuildersSection />
    </Box>
  );
};
